import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-mapping-detect-prefix',
  templateUrl: './mapping-detect-prefix.component.html',
  styleUrls: ['./mapping-detect-prefix.component.scss']
})
export class MappingDetectPrefixComponent implements OnInit, OnDestroy {
  @HostBinding('class.country-found') classCountryFound;
  @Input() form: FormGroup;
  private libPhoneNumber = require('libphonenumber-js');
  private formatter = new this.libPhoneNumber.AsYouType();

  constructor() {}

  ngOnInit() {
    this.form.get('isoCountry').valueChanges.subscribe(value => (this.classCountryFound = !!value));
    if (this.form.get('pattern').value) {
      this.onChangeInputValue(this.form.get('pattern').value);
    }
  }

  onChangeInputValue(value) {
    let pattern;
    if (value.target) {
      pattern = value.target.value = this.checkStartZero(value.target.value);
    } else {
      pattern = value;
    }
    if (pattern) {
      this.formatter.reset();
      this.formatter.input(pattern);
      const country = this.formatter.country || this.formatter.metadata._country;
      if (country) {
        this.form.get('isoCountry').setValue(country.toLowerCase());
      }
      if (pattern.length <= 1) {
        this.form.get('isoCountry').setValue(null);
      }

      this.form.get('pattern').updateValueAndValidity();
    }
  }

  checkStartZero(pattern) {
    if (pattern && pattern.startsWith('00')) {
      pattern = `+${pattern.slice(2)}`;
    }
    return pattern;
  }

  ngOnDestroy(): void {
    this.form.markAsUntouched();
  }
}
